const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = ['Submodel'];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const categorySelectionPageUrl = '/collections';
const brandSelectionPageUrl = '/pages/brands';
const defaultPageSize = 30;

function responseHandler(response) {
  const pageType = window.Convermax.Shopify.getPageType();

  if (pageType === 'collection' || pageType === 'vendors') {
    const { selection, query, sort, pageSize, pageNumber } = window.Convermax.getSearchRequest();
    const isVehicleSelected = window.Convermax.isVehicleSelected();
    const vehicleRequestParams = window.Convermax.getVehicleRequestParams();

    if (
      isVehicleSelected ||
      vehicleRequestParams !== '' ||
      selection.length > 0 ||
      query.length > 0 ||
      pageNumber > 0 ||
      pageSize !== defaultPageSize ||
      sort !== 'relevance' ||
      window.document.querySelector('.cmTemplate_timeout') ||
      window.document.querySelector('.cmTemplate_networkError')
    ) {
      window.document.body.classList.add('cm_hideDefaultResults');
    }
  }

  return response;
}

export default {
  platform: 'shopify',
  searchPageUrl: '/search',
  defaultView: 'productGrid',
  sortFields: [
    'relevance',
    'title',
    'title:desc',
    'collection_sort',
    'price',
    'price:desc',
    'published_at',
    'published_at:desc',
  ],
  responseHandler,
  SearchRequestDefaults: {
    pageSize: defaultPageSize,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'vendor' },
    ],
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm_category-page',
      template: 'MainContent',
    },
    {
      name: 'CategoryFacetPanel',
      type: 'FacetPanel',
      location: '#cm_category-facet-panel',
      template: 'FacetPanelContainer',
      ignoreFields,
    },
    {
      name: 'SearchBox',
      location: { replace: '.search.search-modal__form' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '.header-mobile .item__mobile--search',
        class: 'cm_search-box-dialog-button_container header-mobile--icon',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'StickySearchBoxDialogButtonDesktop',
      type: 'SearchBoxDialogButton',
      location: {
        replace: 'sticky-header .header-bottom .header__search',
        class: 'header__iconItem header__search',
      },
      template: 'searchBox/dialogButtonDesktop',
    },
    {
      name: 'MobileBottomMenuSearchBoxDialogButton',
      type: 'SearchBoxDialogButton',
      location: {
        replace: '.halo-sticky-toolbar-mobile .list-item a[cm_data-search-mobile] .icon',
        class: 'icon cm_bottom-search-box-dialog-button_container',
      },
      template: 'searchBox/dialogButtonDesktop',
    },
    {
      name: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    { name: 'SearchResult' },
    {
      name: 'SearchHeader',
      pageSizes: [30, 10, 15, 20, 25, 50],
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: 'body.template-index .shopify-section.sections-slide-show',
        class: 'cm_vehicle-widget__home-container',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 680,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 680,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.header-top .header__icon.header__icon--cart',
        class: 'header__icon cm_garage-container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'StickyGarage',
      type: 'Garage',
      location: {
        insertBefore: 'sticky-header .header-bottom .header__icon.header__icon--cart',
        class: 'header__iconItem cm_garage__sticky cm_garage-container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: {
        insertBefore: '.header-mobile--right .header-mobile--icon.item__mobile--cart',
        class: 'header-mobile--icon cm_garage__mobile',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/collapsibleVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: true,
    },
    {
      name: 'FitmentTable',
      location: 'body.template-product .tab-content#tab-fitment .tab-popup-content',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: 'body.template-product .tab.fitment .tab-title',
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'MobileFitmentTableTab',
      type: 'FitmentTable',
      location: 'body.template-product .tab-content#tab-fitment .toggleLink',
      template: 'fitmentSearch/mobileFitmentTableTab',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: 'body.template-list-collections .halo-collection-content.halo-grid-content',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm_brand-selection-page',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      ignoreFields,
    },
  ],
};
